export default __webpack_public_path__ + "static/media/Helvetica-Neue-Condensed-Black.4ca45686.ttf";